import { render, staticRenderFns } from "./ConsumerDefense.vue?vue&type=template&id=6b5ea8be&scoped=true&"
import script from "./ConsumerDefense.vue?vue&type=script&lang=js&"
export * from "./ConsumerDefense.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDefense.vue?vue&type=style&index=0&id=6b5ea8be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ea8be",
  null
  
)

export default component.exports